module.exports = __webpack_public_path__ + "static/individual@2x-f14a487b31eee3c6d34431a940034711.png";